import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from './App';
import { useAuthStore } from './lib/auth-store';
import { queryClient } from './lib/queryClient';
import { registerServiceWorker } from './sw-register';
import { iniciarSync } from './lib/sync';
import { initTheme } from './lib/theme';
import './styles/global.css';

// Aplica tema antes do primeiro render (já restaurado por inline script no index.html)
initTheme();

// Hidrata auth a partir do storage persistente antes do primeiro render
void useAuthStore.getState().hydrate();

// Registra service worker (auto-update). Falhas são silenciosas.
void registerServiceWorker();

// Inicia o loop de sincronização offline-first (idempotente).
void iniciarSync().catch(() => undefined);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
